"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfOrientationSearchDto = instanceOfOrientationSearchDto;
exports.OrientationSearchDtoFromJSON = OrientationSearchDtoFromJSON;
exports.OrientationSearchDtoFromJSONTyped = OrientationSearchDtoFromJSONTyped;
exports.OrientationSearchDtoToJSON = OrientationSearchDtoToJSON;
exports.OrientationSearchDtoToJSONTyped = OrientationSearchDtoToJSONTyped;
const State_1 = require("./State");
/**
 * Check if a given object implements the OrientationSearchDto interface.
 */
function instanceOfOrientationSearchDto(value) {
    return true;
}
function OrientationSearchDtoFromJSON(json) {
    return OrientationSearchDtoFromJSONTyped(json, false);
}
function OrientationSearchDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'startFromRecord': json['startFromRecord'] == null ? undefined : json['startFromRecord'],
        'profileId': json['profileId'] == null ? undefined : json['profileId'],
        'startDate': json['startDate'] == null ? undefined : (new Date(json['startDate'])),
        'endDate': json['endDate'] == null ? undefined : (new Date(json['endDate'])),
        'minimumPayRate': json['minimumPayRate'] == null ? undefined : json['minimumPayRate'],
        'jurisdictions': json['jurisdictions'] == null ? undefined : (json['jurisdictions'].map(State_1.StateFromJSON)),
        'specialtyCodes': json['specialtyCodes'] == null ? undefined : json['specialtyCodes'],
        'noSpecialty': json['noSpecialty'] == null ? undefined : json['noSpecialty'],
        'lat': json['lat'] == null ? undefined : json['lat'],
        'lng': json['lng'] == null ? undefined : json['lng'],
        'radiusInMiles': json['radiusInMiles'] == null ? undefined : json['radiusInMiles'],
        'facilities': json['facilities'] == null ? undefined : json['facilities'],
    };
}
function OrientationSearchDtoToJSON(json) {
    return OrientationSearchDtoToJSONTyped(json, false);
}
function OrientationSearchDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'startFromRecord': value['startFromRecord'],
        'profileId': value['profileId'],
        'startDate': value['startDate'] == null ? undefined : ((value['startDate']).toISOString()),
        'endDate': value['endDate'] == null ? undefined : ((value['endDate']).toISOString()),
        'minimumPayRate': value['minimumPayRate'],
        'jurisdictions': value['jurisdictions'] == null ? undefined : (value['jurisdictions'].map(State_1.StateToJSON)),
        'specialtyCodes': value['specialtyCodes'],
        'noSpecialty': value['noSpecialty'],
        'lat': value['lat'],
        'lng': value['lng'],
        'radiusInMiles': value['radiusInMiles'],
        'facilities': value['facilities'],
    };
}
//# sourceMappingURL=OrientationSearchDto.js.map